import * as types from './types';
import { updateApplication } from "./applicationActions";

export const updateOtherInfo = (updates) => {
  return {
    type: types.UPDATE_OTHER_INFO,
    updates
  }
};

export const toggleLifeCircumstances = () => {
  return {
    type: types.TOGGLE_LIFE_CIRCUMSTANCES
  }
};

export const updateTeas = (updates) => {
  return {
    type: types.UPDATE_TEAS,
    updates
  }
};

export const saveOtherInfo = (other) => {
  return updateApplication({other});
};